import { createFileRoute } from '@tanstack/react-router'

import { EstimateForm } from './-components/forms/estimate-form'

export const Route = createFileRoute('/_blue_header/devis')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex w-full flex-col gap-9">
      <div className="flex w-full flex-col gap-2">
        <div className="text-gray-light-900 text-2xl font-semibold">
          Demande de devis sur-mesure
        </div>
        <div className="flex gap-1">
          <div className="text-gray-light-900 text-sm">Nos équipes vous répondront sous</div>
          <div className="text-gray-light-900 text-sm font-bold">72h (maximum)</div>
        </div>
      </div>
      <EstimateForm />
    </div>
  )
}
